module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "branch"
  }, [_c('div', {
    staticClass: "notifications"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "message message--success"
    }, [_c('h3', {
      staticClass: "message__title"
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('p', {
      staticClass: "message__content"
    }, [_vm._v(_vm._s(notification.message))])])
  }), 0), _vm._v(" "), _c('router-view', {
    staticClass: "view"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ff813f5!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/Branch.vue
// module id = 739
// module chunks = 1